import { getCurrentBreakpoint } from './Responsive.helper';

const PASSIVE = { passive: true };

let componentsList = [];
let hasListener = false;

function shouldBreakpointChange(component, currentBreakpoint) {
  component.setState((state) => {
    if (state.currentBreakpoint === currentBreakpoint) {
      return null;
    }

    return { currentBreakpoint };
  });
}

function listener() {
  const currentBreakpoint = getCurrentBreakpoint();

  componentsList.map((component) => shouldBreakpointChange(component, currentBreakpoint));
}

function subscribe(component) {
  componentsList.push(component);

  if (!hasListener) {
    hasListener = true;
    window.addEventListener('resize', listener, PASSIVE);
  }
}

function unsubscribe(component) {
  componentsList = componentsList.filter((item) => item !== component);

  if (!componentsList.length && hasListener) {
    hasListener = false;
    window.removeEventListener('resize', listener, PASSIVE as AddEventListenerOptions);
  }
}

export { subscribe, unsubscribe };
